import { api } from './client'

/**
 * R3-22 (REQ-026-003) — report dedicati (`DedicatedReportsController`, flag `report.dedicati`, policy Manager).
 * Con il flag spento il server risponde `{ enabled: false }`. Le chiavi economiche (`presumed`, `accrued`,
 * `collected`) esistono solo per chi ha la lettura amministrativa.
 */
export interface DedicatedPeriod { from: string; to: string; timeZone: string }

export interface DedicatedDisabled { enabled: false }

export interface FlowWireRow {
  key: string
  label: string
  rank: number | null
  inserted: number
  activated: number
  rejected: number
  cancelled: number
  suspended: number
  reversed: number
  activationRate: number | null
  rejectionRate: number | null
  reversalRate: number | null
  presumed?: number
  accrued?: number
  collected?: number
}

export interface RevenueWireRow { key: string; label: string; presumed: number; accrued: number; collected: number }
export interface RevenueStatesWire { presumed: number; accrued: number; collected: number }

export interface RevenueReport {
  enabled: true
  money: boolean
  period: DedicatedPeriod
  message?: string
  total?: RevenueStatesWire
  collectionRate?: number | null
  byMonth?: ({ month: string } & RevenueStatesWire)[]
  byDepartment?: RevenueWireRow[]
  byOperator?: RevenueWireRow[]
  limitations?: string[]
}

export interface QualityReport {
  enabled: true
  period: DedicatedPeriod
  total: FlowWireRow
  byDepartment: FlowWireRow[]
  byOperator: FlowWireRow[]
  byAgent: FlowWireRow[]
  limitations: string[]
}

export interface BackofficeReport {
  enabled: true
  period: DedicatedPeriod
  queue: { key: string; label: string; n: number }[]
  exceptions: { created: number; resolved: number; resolutionRate: number | null }
  sla: { breached: number }
  batches: { created: number; pending: number; approved: number; rejected: number; medianApprovalHours: number | null }
  limitations: string[]
}

export interface RowsReport {
  enabled: true
  money: boolean
  period: DedicatedPeriod
  rows: FlowWireRow[]
  limitations?: string[]
}

function qs(from?: string, to?: string): string {
  const p = new URLSearchParams()
  if (from) p.set('from', from)
  if (to) p.set('to', to)
  const s = p.toString()
  return s ? `?${s}` : ''
}

export const dedicatedReportsApi = {
  revenue: (from?: string, to?: string) => api<RevenueReport | DedicatedDisabled>(`/api/reports/dedicated/revenue${qs(from, to)}`),
  quality: (from?: string, to?: string) => api<QualityReport | DedicatedDisabled>(`/api/reports/dedicated/quality${qs(from, to)}`),
  backoffice: (from?: string, to?: string) => api<BackofficeReport | DedicatedDisabled>(`/api/reports/dedicated/backoffice${qs(from, to)}`),
  sectors: (from?: string, to?: string) => api<RowsReport | DedicatedDisabled>(`/api/reports/dedicated/sectors${qs(from, to)}`),
  agentRanking: (from?: string, to?: string) => api<RowsReport | DedicatedDisabled>(`/api/reports/dedicated/agent-ranking${qs(from, to)}`),
}
